/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { QuoteStatusChip_QuoteFragmentDoc } from './QuoteStatusBadge.generated.js';
import { QuoteMenu_QuoteFragmentDoc, QuoteMenu_ProjectFragmentDoc } from './QuoteMenu.generated.js';
import { CreateQuotePdfIconButton_QuoteFragmentDoc } from './buttons/CreateQuotePdfIconButton.generated.js';
export type QuoteSubHeader_QuoteFragment = { __typename: 'Quote', id: string, viewerPermissions: Array<Types.PermissionName>, owningSystemOrganisationId: string, title: string, number: string, isPublished: boolean, isBinding: boolean, needsAgreement: boolean, agreement: Types.Agreement, canBeDeleted: boolean, templateOriginQuoteId?: string | null, rootItem: { __typename: 'Item', id: string, originVersionNumber?: number | null }, documents: Array<{ __typename: 'QuoteDocument', id: string, name: string, source: Types.QuoteDocumentSource, calculationType?: Types.QuotePdfCalculationType | null, createdAt: any, createdBy: { __typename: 'User', id: string, firstname: string, familyname: string }, file: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, group: string, url: string } }>, agreedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null };

export type QuoteSubHeader_ProjectFragment = { __typename: 'Project', id: string };

export const QuoteSubHeader_QuoteFragmentDoc = gql`
    fragment QuoteSubHeader_Quote on Quote {
  id
  viewerPermissions
  owningSystemOrganisationId
  title
  number
  isPublished
  ...QuoteStatusChip_Quote
  ...QuoteMenu_Quote
  ...CreateQuotePdfIconButton_Quote
  rootItem {
    id
    originVersionNumber
  }
}
    ${QuoteStatusChip_QuoteFragmentDoc}
${QuoteMenu_QuoteFragmentDoc}
${CreateQuotePdfIconButton_QuoteFragmentDoc}`;
export const QuoteSubHeader_ProjectFragmentDoc = gql`
    fragment QuoteSubHeader_Project on Project {
  id
  ...QuoteMenu_Project
}
    ${QuoteMenu_ProjectFragmentDoc}`;